import styled from 'styled-components';

import { SelectColor } from '../../../../services/reports';

export const StyledCampaignRange = styled.div`
  margin-top: 30px;
  
  .content-1200 {
  	margin-top: 40px;
  }
  
  section {
    padding: 0 20px;
    
    h2 {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      font-size: 15px;
      color: #2B2932;
      margin: 0 0 10px 0;
    }
    
    p {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5em;
      color: #2B2932;
      margin: 0;
    }
  }
  
  hr {
  	margin: 30px 0;
    border-color: #F5F7F9;
  }
  
  @media screen and (min-width: 1350px) {
      .content-charts {
        height: 100%;
      }
  }
  
  @media screen and (max-width: 1366px) {
    .content-charts {
      height: 100%;
    }
  }
  
  @media screen and (max-width: 850px) {
    .content-charts {
      height: 100%
    }
  }
  
  .legend {
    display: flex;
    align-items: center;
    font-family: Poppins, Heltica, Arial, sans-serif;
    color: #707070;
    font-size: 14px;
    margin: -20px 80px 0;
    
    @media screen and (max-width: 1280px) {
    	margin: -50px 80px 0;
    }
    
    @media screen and (max-width: 850px) {
        margin: 0 80px 0;
    }
    
    div:first-child {
      margin-right: 15px;
    }
    
    .topic-1,
    .topic-2 {
      &:before {
        content: '';
        width: 15px;
        height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        border-radius: 2px;
      }
    }
    
    .topic-1:before {
      background-color: ${props => SelectColor(props.channel, 'clicks')};
    }
    
    .topic-2:before {
      background-color: ${props => SelectColor(props.channel, 'impressions')};
    }
  }
`;
